import { QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { NotificationStore, NotificationState, NotificationType } from './notification.store';

@Injectable({
  providedIn: 'root'
})
export class NotificationQuery extends QueryEntity<NotificationState, NotificationType> {
  constructor(protected store: NotificationStore) {
    super(store);
  }

  selectNotificationByScope(scope: string): Observable<NotificationType[]> {
    return this.selectAll({
      filterBy: entity => entity.scope === scope
    });
  }
}
